import React from 'react';
import PropTypes from 'prop-types';
import SplitDateRangePicker from 'eventbrite_design_system/datePicker/SplitDateRangePicker';
import { STYLE_STATIC } from 'eventbrite_design_system/inputField/constants';
import ValidationFormField from 'eventbrite_design_system/validationFormField/ValidationFormField';
import { datePropType } from 'eventbrite_design_system/utils/propTypes';
import EBPropTypes from 'js-utils/prop-types';

export default class ValidatedDate extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        label: EBPropTypes.translation,
        startDate: datePropType,
        endDate: datePropType,
        minDate: datePropType,
        maxDate: datePropType,
        isEndInput: PropTypes.bool,
        required: PropTypes.bool,
    };

    render() {
        const {
            id,
            name,
            label,
            startDate,
            endDate,
            minDate,
            maxDate,
            isEndInput,
            required,
        } = this.props;

        return (
            <ValidationFormField
                id={id}
                name={name}
                label={label}
                startDate={startDate}
                endDate={endDate}
                minDate={minDate}
                maxDate={maxDate}
                v2={true}
                required={required}
            >
                <SplitDateRangePicker
                    isEndInput={isEndInput}
                    style={STYLE_STATIC}
                />
            </ValidationFormField>
        );
    }
}
